import './ccf-interaction-complete-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';


/* eslint-disable-next-line */
export interface CcfInteractionCompleteIconProps extends SvgIconProps {}

/**
 * Component to display interaction completed icon
 * @param props - CcfInteractionCompleteIconProps
 * @example <CcfInteractionCompleteIcon />
 * @returns 
 */
export function CcfInteractionCompleteIcon(
  props: CcfInteractionCompleteIconProps
) {
  return (
    <SvgIcon {...props}>
      <g id="ic_interaction_complete">
    <g id="ic_InteractionComplete" transform="translate(-171.783 -15.283)">
      <g id="Ellipse_4729" data-name="Ellipse 4729" transform="translate(172.783 16.783)" fill="none" stroke="#39c44a" strokeWidth="3">
        <circle cx="14" cy="14" r="14" stroke="none"/>
        <circle cx="14" cy="14" r="12.5" fill="none"/>
      </g>
      <path id="Path_25093" data-name="Path 25093" d="M1234.293,37.609l4.521,4.521,7.479-7.479" transform="translate(-1053.51 -7.867)" fill="none" stroke="#39c44a" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfInteractionCompleteIcon;
